import { get } from 'lodash';
import { createSelector } from 'reselect';

export const selectFccCommonData = state => get(state, ['global', 'fccCommon']);

export const selectPermission = createSelector(
  selectFccCommonData,
  commonData => get(commonData, ['permission', 'userInfo'])
);

export const selectUserlist = createSelector(
  selectFccCommonData,
  commonData => commonData.userlist
);

export const selectIsRequest = createSelector(
  selectFccCommonData,
  commonData => commonData.isRequest || commonData.isUserlistRequest
);

export const selectRrCodeCount = createSelector(
  selectFccCommonData,
  commonData => get(commonData, ['permission', 'userInfo', 'rrcodeSize'], 0)
);

export const selectRrCodeList = createSelector(
  selectFccCommonData,
  commonData => get(commonData, ['permission', 'userInfo', 'rrcodeList'], [])
);

export const selectInvitedByFirstName = createSelector(
  selectFccCommonData,
  commonData => get(commonData, ['permission', 'userInfo', 'firstName'], '')
);

export const selectInvitedByLastName = createSelector(
  selectFccCommonData,
  commonData => get(commonData, ['permission', 'userInfo', 'lastName'], '')
);

export const selectGenerateCode = createSelector(
  selectFccCommonData,
  userDetail => userDetail.generateCode
);

export const selectGenerateCodeError = createSelector(
  selectFccCommonData,
  userDetail => userDetail.generateCodeError
);

export const selectGenerateCodeSuccess = createSelector(
  selectFccCommonData,
  userDetail => userDetail.generateCodeSuccess
);

export const selectResendSuccess = createSelector(
  selectFccCommonData,
  userDetail => userDetail.resendInvitationSuccess
);

export const selectResendError = createSelector(
  selectFccCommonData,
  userDetail => userDetail.resendInvitationError
);

export const selectIsSendInvition = createSelector(
  selectFccCommonData,
  commonData => commonData.isSendInvition
);

export const selectIsGenerateCode = createSelector(
  selectFccCommonData,
  commonData => commonData.isGenerateCode
);

export const selectResendUserId = createSelector(
  selectFccCommonData,
  userDetail => userDetail.resendUserId
);

export const selectUserReportInfo = createSelector(
  selectFccCommonData,
  commonData => commonData.userReportInfo
);

export const selectIsReportRequest = createSelector(
  selectFccCommonData,
  commonData => commonData.isReportRequest
);

export const selectIsDownloadFile = createSelector(
  selectFccCommonData,
  commonData => commonData.isDownloadFile || commonData.isUserlistRequest
);

export const selectExportNotification = createSelector(
  selectFccCommonData,
  commonData => commonData.exportNotification || commonData.isUserlistRequest
);

export const selectShowDownloadNoti = createSelector(
  selectFccCommonData,
  commonData => commonData.showDownloadNoti || commonData.isUserlistRequest
);

export const selectDownloadErrorType = createSelector(
  selectFccCommonData,
  commonData => commonData.errorType || commonData.isUserlistRequest
);

export const selectIsCancelInvition = createSelector(
  selectFccCommonData,
  commonData => commonData.isCancelInvition
);

export const selectCancelInvationSuccess = createSelector(
  selectFccCommonData,
  userDetail => userDetail.cancelInvitationSuccess
);

export const selectCancelInvationError = createSelector(
  selectFccCommonData,
  userDetail => userDetail.cancelInvitationError
);

export const selectIsDeleteInvestor = createSelector(
  selectFccCommonData,
  commonData => commonData.isDeleteInvestor
);

export const selectDeleteInvestorSuccess = createSelector(
  selectFccCommonData,
  userDetail => userDetail.deleteInvestorSuccess
);

export const selectDeleteInvestorError = createSelector(
  selectFccCommonData,
  userDetail => userDetail.deleteInvestorError
);

export const selectDeleteInvestorNotification = createSelector(
  selectFccCommonData,
  userDetail => userDetail.userListDeleteNotificationFlag
);

export const selectUserlistSearchData = createSelector(
  selectFccCommonData,
  userDetail => userDetail.searchData
);

export const selectCountryCodeList = createSelector(
  selectFccCommonData,
  userDetail => userDetail.countryCodes
);
